import cookie from "modules/cookie";
import languageListTemplate from "./CountrySelector.hbs";
import notificationTemplate from "../Notifications/Notifications.hbs";

import { Component } from "modules/Component";

import "./country-selector.scss";

interface Language {
    name: string;
    language: string;
    code: string;
    twoLetterISO: string;
    url: string;
    selected: boolean;
}

interface Country {
    countryTitle: string;
    multilingual: boolean;
    active: boolean;
    countryCode: string | null;
    code: string;
    countrySuggestionTitle: string | null;
    countrySuggestionText: string | null;
    countrySuggestionLinkText: string | null;
    languages: Language[];
}

export class CountrySelector extends Component<typeof CountrySelector> {
    public static className: string = "js-country-selector-component";

    private store = {
        countries: [] as Country[],
    }

    async init(countrySelectorElement: HTMLElement) {
        try {
            this.store.countries = await this.getCountries();
        } catch (error) {
            console.error("Error fetching countries:", error);
            return;
        }

        countrySelectorElement.innerHTML = languageListTemplate(this.store.countries);

        const activeCountry = this.store.countries.find(country => country.active);

        if (
            activeCountry === undefined || 
            activeCountry.countryTitle !== "Securitas.com"
        ) {
            return;
        }

        const visitorCountryCode = await this.getVisitorCountryCode();

        if (visitorCountryCode === "Not_Found") {
            return;
        }

        const countriesToRecommend: Country[] = [];
        const recommendedCountryCodes = cookie.getCookie("NotificationPopup");

        const visitorCountries = this.store.countries.filter(
            (country) => country.countryCode === visitorCountryCode
        );

        if (visitorCountries.length === 0) {
            return;
        }

        visitorCountries.forEach((visitorCountry) => {
            visitorCountry.languages.forEach((language) => {
                if (!recommendedCountryCodes.includes(language.code)) {
                    countriesToRecommend.push(visitorCountry);
                }
            });
        });

        if (countriesToRecommend.length > 0) {
            this.renderNotification(
                countriesToRecommend
            );
        }
    }

    getCountries() {
        return new Promise<Country[]>((resolve, reject) => {
            fetch(`/api/countries/GetCountries?url=${encodeURIComponent(window.location.href)}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    resolve(data.countries);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getVisitorCountryCode() {
        return new Promise<string>((resolve, reject) => {
            fetch("/api/notification/GetCountry")
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.text();
                })
                .then((currentCountryCode) => {
                    resolve(currentCountryCode);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    renderNotification(countries: Country[]) {
        const notifications = document.querySelector<HTMLDivElement>("#notifications");

        if (!notifications) {
            return;
        }

        notifications.innerHTML = notificationTemplate(countries);

        const closeButtons = document.querySelectorAll(".notification__close");

        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener("click", this.handleCloseButtonClick);
        });
    }

    handleCloseButtonClick = (e: Event) => {
        const cookieLanguageNotification = cookie.getCookie(
            "NotificationPopup"
        );

        if (!e.target || !(e.target instanceof HTMLButtonElement)) {
            return;
        }

        (e.target.parentNode as HTMLElement).remove();

        const countryCode = e.target.dataset.code;

        if (!countryCode) {
            return;
        }

        let recommendedCountryCodes: string[] = [];

        if (cookieLanguageNotification != "") {
            recommendedCountryCodes = cookieLanguageNotification.split(",");
        }

        recommendedCountryCodes.push(countryCode);
        cookie.setCookie("NotificationPopup", recommendedCountryCodes.join(","), 30);
    }
}
